import { Info } from "lucide-react";
import { YIELD_DISCLAIMER, GLOBAL_DISCLAIMER } from "../data/site";

export const YieldDisclaimer = ({ variant = "yield", className = "" }) => {
  const text = variant === "global" ? GLOBAL_DISCLAIMER : YIELD_DISCLAIMER;
  return (
    <div
      data-testid={variant === "global" ? "global-disclaimer" : "yield-disclaimer"}
      className={`flex items-start gap-2 text-[10px] md:text-[11px] text-white/45 leading-relaxed ${className}`}
    >
      <Info size={12} className="shrink-0 mt-0.5 text-[#c5a059]/60" />
      <span className="italic">{text}</span>
    </div>
  );
};
